import { CommonModule } from '@angular/common';
import {
	AfterContentInit,
	AfterViewInit,
	Component,
	CUSTOM_ELEMENTS_SCHEMA,
	inject,
	Input,
	OnInit
} from '@angular/core';
import { Router } from '@angular/router';
import { StateService } from 'src/app/core';

export const CourseCardEvent = {
	CLICK: 'lua-ai-smart-search:course-card-click'
};

@Component({
	selector: 'angie-lua-ai-smart-search',
	template: `<lua-ai-smart-search [as3_main_bucket_s3_host]="s3HostUrl"></lua-ai-smart-search>`,
	standalone: true,
	imports: [CommonModule],
	schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AngieLuaAiSmartSearchComponent implements AfterContentInit, AfterViewInit, OnInit {
	@Input() configId: string = 'ai-smart-config';

	stateService = inject(StateService);
	router = inject(Router);

	s3HostUrl = this.stateService.portalMeta.as3_main_bucket_s3_host;

	ngOnInit(): void {
		window.addEventListener(CourseCardEvent.CLICK, (event: any) => {
			this.redirectLearnerToContentDetails(event);
		});
	}

	ngAfterContentInit(): void {
		//@ts-ignore
		LuAnywhere.autoload();
	}

	ngAfterViewInit(): void {
		const script = document.createElement('script');
		script.setAttribute('type', 'application/json');
		script.setAttribute('preload-resource', encodeURIComponent('{}'));
		document.head.appendChild(script);
	}

	private redirectLearnerToContentDetails(event: CustomEvent) {
		const { course_id } = event.detail;
		const URL = `/content-details/${course_id}/0`;
		this.router.navigateByUrl(URL);
	}
}
